import {Select} from '@wandb/weave/components/Form/Select';
import React, {type Key, useCallback, useMemo} from 'react';
import {components, type InputAction} from 'react-select';

import {SettingLabel} from '../components/SettingLabel';
import {
  type GroupedSourceNotebookOption,
  type SourceNotebookOption,
} from './useNotebookItems';

const CustomSingleValue = (props: any) => {
  return (
    <components.SingleValue {...props}>
      <div>{props.data.singleValue}</div>
    </components.SingleValue>
  );
};

const CustomOption = (props: any) => {
  return <components.Option {...props}>{props.data.option}</components.Option>;
};

const CUSTOM_COMPONENTS = {
  SingleValue: CustomSingleValue,
  Option: CustomOption,
};

// filtering is done on the backend search
function filterOption() {
  return true;
}

export const SourceNotebookSelect = ({
  notebookItems,
  loading,
  onInputChange,
  onMenuScrollToBottom,
  onBlur,
  selectedOptionID,
  setSelectedOptionID,
}: {
  selectedOptionID: string | null;
  setSelectedOptionID: (value: string | null) => void;
  notebookItems: GroupedSourceNotebookOption[];
  loading: boolean;
  onInputChange: (newValue: string, {action}: {action: InputAction}) => void;
  onMenuScrollToBottom: () => Promise<void>;
  onBlur: () => void;
}) => {
  const selectedOption = useMemo(() => {
    const options = notebookItems.flatMap(item => item.options);
    return options.find(option => option.value === selectedOptionID);
  }, [notebookItems, selectedOptionID]);
  const onChange = useCallback(
    (value: SourceNotebookOption | null) => {
      setSelectedOptionID(value?.value ?? null);
    },
    [setSelectedOptionID]
  );

  return (
    <div className="flex flex-col gap-y-4">
      <SettingLabel text="Source Notebook" className="w-full" />
      <Select<SourceNotebookOption, false, GroupedSourceNotebookOption>
        options={notebookItems}
        components={CUSTOM_COMPONENTS}
        isSearchable
        isLoading={loading}
        placeholder="Select a notebook"
        onMenuScrollToBottom={onMenuScrollToBottom}
        onInputChange={onInputChange}
        filterOption={filterOption}
        onBlur={onBlur}
        groupDivider
        value={selectedOption}
        onChange={onChange}
      />
    </div>
  );
};
